import {FC, useState} from 'react'

interface Props {
    booking?: Booking,
    setBooking: Function
}

const ChipCount: FC<Props> = ({ booking, setBooking}) => {
    const set = (num:number) => {
        booking.window.form.chip_counter = num
        setBooking({
            ...booking,
        })
    }

    return (
        <div className="chip-count">
            <div className={booking.window.form.chip_counter === 1 ? ('chip-count__btn active') : ('chip-count__btn')} onClick={() => set(1)}>1</div>
            <div className={booking.window.form.chip_counter === 2 ? ('chip-count__btn active') : ('chip-count__btn')} onClick={() => set(2)}>2</div>
            <div className={booking.window.form.chip_counter === 3 ? ('chip-count__btn active') : ('chip-count__btn')} onClick={() => set(3)}>3</div>
        </div>
    )
};

export default ChipCount
